import React, {useEffect} from 'react'
import { useQuery } from 'react-query';
import Loadingcomponent from '../../../components/loader/loadingcomponent';
import ErrorMessage from '../../../components/messaging/errormessage';
import { GetCacheKey } from '../../../services/common/utils';
import RoamingRatesComponent from "../../../pages/roaming/roaming-rates";
import { PASSPORT_ROAMING_INT_RATES_LIST_URL } from '../../../services/common/endpoints';
import RoamingInterComponent from "../../../pages/roaming/roaming-inter-rates";
import { useTranslation } from 'react-i18next';
import {useSelector} from "react-redux";
import {GTMScreenView} from "../../../../src/analytics/GoogleTagManager";
import {CT_Events} from "../../../../src/analytics/CTEvents";
import RoamingInternationalComponent from './roaming-international-rates';
import PageShimmer from '../../loader/skeletons/common/page-shimmer';

const RoamingInternationalRatesIndex = () => {
  const {
    data: { data } = {},
    isLoading,
    error,
    isFetching,
    isError,
    isLoadingError
  } = useQuery([GetCacheKey('roaming_home'), PASSPORT_ROAMING_INT_RATES_LIST_URL.url, PASSPORT_ROAMING_INT_RATES_LIST_URL.data, {}], {
    retry: false,
    retryOnMount: false,
  });
  const {CT_ScreenView} = CT_Events();
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const msisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
  const { t } = useTranslation();
  useEffect(() =>{
    try{
      GTMScreenView("Roaming_InterRates", msisdn, logintype);
    }catch{}
    try{
      CT_ScreenView();
    }catch{}
  }, [])
  if (isLoading || isFetching) {
    return (
      <PageShimmer  />
    );
  }

  if (error || isError || isLoadingError) {
    return <div class="body_container">

      <section class="">
        <div class="bottom_bg_section">
          <div class="bottom_bg_section_container">
            <img src="assets/images/assets_bg.jpg" alt="" />
          </div>
        </div>
        <div class="center_section">
          <div class="sec_top mt-160">
            <div class="pse_md">
              <div class="text-center mb-5">
                <div class="mb-5">
                  <picture>
                    <img src={process.env.PUBLIC_URL + '/assets/images/error_red.svg'} width="{100px}" alt="" title="" />
                  </picture>
                </div>
                <div>
                  <h2 class="mb-2 page_title_v1 primary_color">{t("errorMsg")}</h2>
                  <p class="mb-3 primary_14 dark_gray_color">{t("somethingwentwrong")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  }

  // console.log('RoamingComponent_data', data);
  const getPageComponents = (pmsitem) => {
    switch (pmsitem?.templatetype) {
      case '127': {
        // console.log(pmsitem, "hirjwlrj")
        return <RoamingInternationalComponent pmsitem={pmsitem} />
        break;
      }
      default: {
        return <></>
      }
    }
  }
  return (
    <>
      {
        data?.data?.map(item => {
          return (
            <>{getPageComponents(item)}</>
          )
        })
      }
    </>

  )
}

export default RoamingInternationalRatesIndex